let expireUser = null

export const setGlobal401Handler = (fn) => {
  expireUser = fn
}

export const trigger401Handler = () => {
  if (expireUser) {
    expireUser()
  }
}
